//IMPORTAÇÕES
import React, { useState, useEffect, useRef } from 'react';
import { Button, Form } from 'react-bootstrap';

import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
import {setaDropdown} from '../../../utils/alternanciaIcones'


export default function SelectValidadePlano(props) {
    const [spinAtivo, setSpinAtivo] = useState(true);
   
    const modal = useRef();

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };


    function handleValidadePlano(validadePlano){

        if(validadePlano === 0) {
            props.setDsValidadePlano('Sem fidelidade')
        } else {
            props.setDsValidadePlano(validadePlano)
        }
        handleCancelar()
    }

    function handleCancelar(){
        props.setRevelarSelectValidadePlano(false)
    }

    useEffect(() => {
        setSpinAtivo(true)
        setSpinAtivo(false)
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);
    }, [])


    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select" onClick={() => props.setRevelarSelectValidadePlano(false)}>
                <div className="fonte-cor-1 label-campo">{props.dsValidadePlano}</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
            <div className="campo-texto-cor-3 campo-select-corpo">
                <ul className="campo-select-lista">
                    <li>
                        <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handleValidadePlano(12)}>
                            <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">12 meses</span>
                        </div>
                        <div className="campo-select-divisor-cor-1 campo-select-divisor" />
                    </li>
                    <li>
                        <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handleValidadePlano(24)}>
                            <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">24 meses</span>
                        </div>
                        <div className="campo-select-divisor-cor-1 campo-select-divisor" />
                    </li>
                    <li>
                        <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handleValidadePlano(36)}>
                            <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">36 meses</span>
                        </div>
                    </li>
                    <div className="campo-select-divisor-cor-1 campo-select-divisor" />
                    <li>
                        <div className="campo-select-opcao campo-select-opcao-1" onClick={() => handleValidadePlano(0)}>
                            <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Sem fidelidade</span>
                        </div>
                    </li>
                </ul>
            </div>
        </Form>
    )
}